import React, { Component } from 'react';
import './KPIList.css';
// import 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import Select from '@acri-tools/react-tools/components/Select/Select';
import { push_history } from '@acri-tools/react-tools/utils/global';
import { date_timezone_compensated, date_timezone_compensated_removed, format_date, getKPIColors, KPI_route_name } from '../../_utils/kpi';
import KPILevel from '../KPILevel/KPILevel';
import { connect } from 'react-redux';
import { setKPI } from '../../actions/action-types';
import { v4 } from 'uuid';
import { getDateTimeString } from '@acri-tools/react-tools/utils/date';

// Number of days max to view
const REDUCED = [
    undefined,
    undefined, //1,
    undefined,
    undefined,
    undefined,
    undefined,
    7,
]

interface Props {
    // data: Array<any>
    kpi_definitions: any
    kpis: any
    kpi_performance_levels: any
    months: Array<string>

    // REDUX
    setKPI?:any
}
interface State{
    loading:boolean
    // dates?: Array<any>
    selectedDate?: any
}

class KPIList extends Component<Props, State>{
    constructor(props:Props){
        super(props);
        // console.log("props.kpis",props.kpis);

        // let dates = Object.keys(props.kpis)
        // .sort((a:string, b:string)=>{ return new Date(b).getTime() - new Date(a).getTime() } );
        // .map((d)=>{ return dateToString(d) });

        // console.log("dates",dates)
        this.state={
            loading: false,
            // dates, 
            selectedDate: props.months[0]
        }
    }

    render() {
        console.debug("KPIS",this.props.kpis)
        return (
            <div className="kpi-list">
                {
                    this.props.months &&
                    <Select
                        value={this.state.selectedDate}
                        onChange={(selectedDate:string)=>{ this.setState({ selectedDate }) }}
                        options={this.props.months.map((date:string, idx:number)=>{ 
                            return {
                                label: idx === 0 ? `Latest ${format_date(date)}` : format_date(date),
                                value: date
                            } 
                        })}
                    />
                }
                <div className="kpis-list">
                    {
                        this.props.kpi_definitions?.map((d: any, key: number) => (
                           this.get_kpi(d, key)
                        ))
                        // this.props.kpis?.[this.state.selectedDate]?.map((d: any, key: number) => (
                        //    this.get_kpi(d, key)
                        // ))
                    }
                </div>
            </div>
        )
    }

    get_kpi = (kpi_definition:any, key:number) =>{
        let kpi = this.props.kpis?.[this.state.selectedDate]?.[kpi_definition.id - 1];
        let kpi_element:React.ReactNode;
        let value_string;
        switch(kpi_definition.id){
            case 1:
            case 3:
            case 4:
            case 6:
            case 7:
            case 8:
                let value = kpi?.value?.percentage ? parseFloat(kpi.value.percentage) : 0;
                console.debug("kpi val", value);
                value_string = value ? `${value}%` : '';
                kpi_element = (
                    <div className="kpi-wrapper">
                        <div className="kpi-value">{value_string || "None"}</div>
                        <Doughnut
                            options={{
                                legend:{
                                    display:false
                                },
                            }}
                            data={ {
                                labels: [ kpi_definition.name, '' ],
                                datasets: [{
                                    label: kpi_definition.name,
                                    data: [ value , 100 - value ],
                                    backgroundColor: getKPIColors(kpi?.level)?.reverse()
                                }],
                                borderWidth: 10
                            }}
                        />
                    </div>
                )
                break;
            case 2:
            case 5:
                if(kpi?.value && 'timeliness' in kpi.value ){
                    let { percentage, timeliness } = kpi.value;
                    if (percentage > 100) { percentage = 100.0 }
                    value_string = `${percentage}% | ${timeliness} day${timeliness > 1 ? 's' : ''} timeliness` 
                }
                else{
                    value_string = kpi?.value?.value;
                }
                kpi_element = (
                    <div className="kpi-wrapper">
                        <KPILevel kpi={kpi}/>
                    </div>
                )
                break;

        }
        return(
            <div key={key} className="kpi">
                { kpi_element }
                <div className="kpi-name" onClick={async()=>{ 
                    push_history(`/kpis/${KPI_route_name(kpi_definition.name)}${this.get_kpi_range(REDUCED[kpi_definition.id - 1])}`)
                    // push_history(`/kpis/${KPI_route_name(kpi_definition.name)}${this.get_kpi_range([2].includes(kpi_definition.id))}`)
                    this.props.setKPI?.({ refresh: v4() })
                }}>{kpi_definition.name}</div>
                {
                    kpi &&
                    <>
                        <div className="kpi-details">Level {kpi.level} - {value_string}</div>
                        {/* <div className="kpi-details">Cost Modulation - {kpi.cost_modulation}%</div> */}
                    </>
                }
            </div>
        )
    }

    get_kpi_range = (reduced_days?:number) =>{
        let start = new Date(this.state.selectedDate);
        let now = new Date();
        let stop;
        if(reduced_days){
            stop = new Date(Date.UTC(
                now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds()
            ));
            start = new Date(Date.UTC(
                now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - reduced_days, now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds()
            ));
        }
        else
            stop = new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth() + 1, 1,0,0,0));

        return `?startDate=${start.toISOString()}&stopDate=${stop.toISOString()}`;
    }

};

export default connect(null,{
    setKPI
})(KPIList)